import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import * as Icons from "lucide-react";

const iconMap = {
  "TikTok Ads": "Music2", "Facebook / Meta Ads": "Facebook", "Google Ads": "Chrome",
  "SEO": "Search", "Landing Page Development": "LayoutTemplate", "Digital Marketing Consulting": "LineChart",
};

export default function ServiceCard({ service, index = 0 }) {
  const { t } = useI18n();
  const IconName = iconMap[service.category] || "Sparkles";
  const Icon = Icons[IconName] || Icons.Sparkles;
  return (
    <div className="card-lux p-6 flex flex-col group fade-up" style={{ animationDelay: `${index * 70}ms` }} data-testid={`service-card-${service.slug}`}>
      <div className="h-12 w-12 rounded-lg bg-gradient-to-br from-amber-400/20 to-amber-600/10 border border-amber-500/30 flex items-center justify-center mb-5 group-hover:scale-105 transition-transform">
        <Icon className="text-amber-400" size={22} />
      </div>
      <div className="label-lux mb-2">{service.category}</div>
      <h3 className="text-lg font-semibold text-white mb-2">{service.name}</h3>
      <p className="text-sm text-slate-400 leading-relaxed flex-1">{service.short_description}</p>
      {service.features?.length > 0 && (
        <ul className="mt-4 space-y-1.5">
          {service.features.slice(0, 3).map((f, i) => (
            <li key={i} className="flex items-start gap-2 text-xs text-slate-400">
              <Check size={14} className="text-amber-400 mt-0.5 shrink-0" /> {f}
            </li>
          ))}
        </ul>
      )}
      <div className="mt-5 pt-4 border-t border-white/5 flex items-center justify-between">
        <div>
          <div className="text-xs text-slate-500">{t("common.from")}</div>
          <div className="font-display font-bold text-white">{service.price} <span className="text-amber-400 text-sm">USDT</span></div>
        </div>
        <Link to={`/services/${service.slug}`} className="gold-btn !py-2 !px-4 text-sm" data-testid={`service-detail-link-${service.slug}`}>
          {t("common.viewService")} <ArrowRight size={15} />
        </Link>
      </div>
    </div>
  );
}
